import { forwardRef } from "react";
import {
  ChakraStylesConfig,
  Select as CRSelect,
  Props,
  StylesConfig,
} from "chakra-react-select";

const selectChakraStyles: ChakraStylesConfig = {
  menuList: (provided) => ({
    ...provided,
    py: 1,
    minWidth: "200px",
    backgroundColor: "grey.50",
  }),
  groupHeading: (provided) => ({
    ...provided,
    backgroundColor: "grey.100",
    margin: "6px 0", // shorthand props are overwritten by a margin prop
    padding: "4px 28px", // shorthand props are overwritten by a padding prop
  }),
  placeholder: (provided) => ({ ...provided, whiteSpace: "nowrap" }),
  option: (provided, state) => {
    const selectedBackgroundColor = state.isSelected ? "navy.400" : "unset";
    return {
      ...provided,
      my: "6px",
      padding: "1px 4px", // shorthand props are overwritten by a padding prop
      backgroundColor: state.isFocused ? "navy.600" : selectedBackgroundColor,
      color: state.isFocused || state.isSelected ? "white" : "unset",
      whiteSpace: "nowrap",
    };
  },
  container: (provided) => ({ ...provided, backgroundColor: "white" }),
};
const selectStyles: StylesConfig = {
  //menuPortal style cannot be set in chakraStyles
  menuPortal: (provided) => ({ ...provided, zIndex: 10000 }),
};
const Select = forwardRef<
  any,
  Props & { selectChakraStyleOverrides?: ChakraStylesConfig }
>(
  (
    {
      isSearchable = false,
      isMulti = false,
      isClearable = true,
      selectChakraStyleOverrides,
      ...props
    },
    ref
  ) => (
    <CRSelect
      ref={ref}
      useBasicStyles
      isSearchable={isSearchable}
      isMulti={isMulti}
      isClearable={isClearable}
      selectedOptionStyle="check"
      hideSelectedOptions={false}
      chakraStyles={{ ...selectChakraStyles, ...selectChakraStyleOverrides }}
      menuPortalTarget={document.body} // Borrowed from https://react-select.com/advanced#portaling
      blurInputOnSelect={true}
      menuPlacement="auto"
      menuPosition="fixed"
      styles={selectStyles}
      {...props}
    />
  )
);

Select.displayName = "Select";

export default Select;
